import React, {useContext, useEffect, useState} from 'react';
import {WMSContext} from "../../../context/WMSContext";
import {
    getShipmentsAndStationsToSort, getWMSContainerWithCodeBar,
    patchWMSContainerMemberWithCodebar
} from "../../../../../api/wms/wmsContainers/wmsContainers";
import {BarCodeScannerContext} from "../../../../../contexts/barCodeScannerContext";
import {launchOmniScan} from "../../../../../api/wms/omiScan";
import {Card, CardContent, Grid} from "@mui/material";
import Toggle from "../../../../../components/WMS/Mobile/Toggle/Toggle";
import {FormattedMessage} from "react-intl";
import ToggleNavigation from "../../../../../components/WMS/Mobile/Toggle/ToggleNavigation";
import {WmsContainerType} from "../../../../../utils/WMSContainerType";
import MobileItem from "../../../../../components/WMS/Mobile/MobileItem";
import {ReactComponent as ArrowRightIcon} from "assets/img/wms/arrow-right.svg";
import ContainerDrawer from "./components/ContainerDrawer";
import TriShippingToast from "./components/TriShippingToast";
import {WMSOmniScanReturnType} from "../../../../../utils/WMSOmniScanReturnType";
import {WMSOmniScanContextKeys} from "../../../../../utils/WMSOmniScanContextKeys";

function TrolleyAndStationList() {
    const {currentInventory, currentMember} = useContext(WMSContext)
    const {scannedString, resetScannedString, setEnableScan} = useContext(BarCodeScannerContext)

    const [scannedShipment, setScannedShipment] = useState()
    const [trolleyAndStationList, setTrolleyAndStationList] = useState([])
    const [openDrawer, setOpenDrawer] = useState(false)
    const [openToast, setOpenToast] = useState(false)
    const [toastType, setToastType] = useState("")
    const [toogleValue, setToogleValue] = useState(0)
    const [inSorting, setInSorting] = useState(false)
    const [currentContainer, setCurrentContainer] = useState()
    const [resetList, setResetList] = useState(false)

    const handleFilterContainer = (value) => {
        setToogleValue(value)
    }

    const getTrolleyCount = () => {
        let count = 0

        trolleyAndStationList.map(container => {
            if (container.type === WmsContainerType.TROLLEY) {
                count++
            }
        })
        return count
    }

    const getPackingStationCount = () => {
        let count = 0

        trolleyAndStationList.map(container => {
            if (container.type === WmsContainerType.PACKING_STATION) {
                count++
            }
        })
        return count
    }

    const openContainerDrawer = (container) => {
        setCurrentContainer(container)
        setOpenDrawer(true)
    }

    const handleCloseDrawer = () => {
        if (inSorting) {
            if (currentContainer.type === WmsContainerType.TROLLEY) {
                patchWMSContainerMemberWithCodebar(currentContainer.codebar, null).then(() => {
                    setInSorting(false)
                })
            } else {
                setInSorting(false)
            }
        }
        resetScannedString()
        setOpenDrawer(false)
    }

    const handleCloseToast = () => {
        setOpenToast(false)
    }

    const beginSorting = (scannedContainer = null) => {
        if (scannedContainer) {
            setCurrentContainer(scannedContainer)
        }

        if (currentMember && (currentContainer?.type === WmsContainerType.TROLLEY || scannedContainer?.type === WmsContainerType.TROLLEY)) {
            patchWMSContainerMemberWithCodebar((currentContainer?.codebar || scannedContainer?.codebar), currentMember).then(() => {
                setInSorting(true)
                if (!openDrawer) {
                    setOpenDrawer(true)
                }
            })
        } else if (currentContainer?.type === WmsContainerType.PACKING_STATION || scannedContainer?.type === WmsContainerType.PACKING_STATION) {
            setInSorting(true)
            if (!openDrawer) {
                setOpenDrawer(true)
            }
        }
    }

    useEffect(() => {
        if (!openDrawer && scannedString && scannedString.length > 0 && !inSorting) {
            setEnableScan(false)
            launchOmniScan(scannedString, currentInventory.id, {
                [WMSOmniScanContextKeys.CONTAINER]: ["trolley", "packing_station"],
                [WMSOmniScanContextKeys.SHIPMENT]: ["ready_to_be_shipped"]
            }).then(response => {
                if (response.length === 1 && response[0].entityType === WMSOmniScanReturnType.CONTAINER && (response[0].type === WmsContainerType.TROLLEY || response[0].type === WmsContainerType.PACKING_STATION)) {
                    const scannedContainer = trolleyAndStationList.find(container => response[0].id === container.id)
                    if (scannedContainer) {
                        beginSorting(scannedContainer)
                    }
                }
                if (response.length === 1 && response[0].entityType === WMSOmniScanReturnType.SHIPMENT) {
                    if (trolleyAndStationList.some(containerList => response[0].currentContainer.id === containerList.id)) {
                        const container = trolleyAndStationList.filter(containerList => response[0].currentContainer.id === containerList.id)
                        const shipment = container[0].shipments.filter(shipmentList => response[0].id === shipmentList.id)
                        setScannedShipment(shipment[0])
                        beginSorting(container[0])
                    }
                    setEnableScan(true)
                }
                if (response.length === 0) {
                    setToastType("omniScanWrongNotFound")
                    setOpenToast(true)
                    setEnableScan(true)
                }
            })
        }
    }, [scannedString]);

    useEffect(() => {
        setEnableScan(true)
        if (currentContainer) {
            const updatedContainer = trolleyAndStationList.find((container) => container.id === currentContainer.id)
            if (updatedContainer) {
                setCurrentContainer(updatedContainer)
                setToastType("parcelSorted")
            } else {
                setOpenDrawer(false)
                setOpenToast(true)
                setToastType("containerSorted")
            }
        }
    }, [resetList, trolleyAndStationList]);

    useEffect(() => {
        if (currentInventory) {
            getShipmentsAndStationsToSort(currentInventory).then(response => {
                setTrolleyAndStationList(response)
            })
        }
    }, [currentInventory, resetList]);
    return (
        <>
            {openDrawer && currentContainer && (
                <ContainerDrawer
                    open={openDrawer}
                    handleClose={handleCloseDrawer}
                    inSorting={inSorting}
                    setInSorting={setInSorting}
                    container={currentContainer}
                    beginSorting={beginSorting}
                    resetList={resetList}
                    setResetList={setResetList}
                    scannedShipment={scannedShipment}
                />
            )}

            {openToast && toastType.length > 0 && (
                <TriShippingToast
                    open={openToast}
                    type={toastType}
                    handleClose={handleCloseToast}
                />
            )}

            <Card>
                <CardContent>
                    <ToggleNavigation
                        value={toogleValue}
                        onChange={(value) => handleFilterContainer(value)}
                        autoMargin
                    >
                        {/* Value is 0 --> trolley */}
                        <Toggle
                            label={<FormattedMessage id={"wms.triShipping.toogleLabel.trolley"}/>}
                            count={getTrolleyCount()}
                            autoHeight
                        />

                        {/* Value is 1 --> packingStation */}
                        <Toggle
                            label={<FormattedMessage id={"wms.triShipping.toogleLabel.packingStation"}/>}
                            count={getPackingStationCount()}
                            autoHeight
                        />
                    </ToggleNavigation>
                </CardContent>
            </Card>

            <Card>
                <CardContent sx={{paddingX: 0}}>
                    <Grid container direction={"column"}>
                        {toogleValue === 0 && trolleyAndStationList.map((container) => {
                            if (container.type === WmsContainerType.TROLLEY) {
                                return (
                                    <div onClick={() => openContainerDrawer(container)}>
                                        <MobileItem>
                                            <MobileItem.LeftSide
                                                title={container.name}
                                                subtitle={<>{container.shipmentCount} <FormattedMessage
                                                    id={"wms.triShipping.shipmentCount"}/></>}
                                            />
                                            <MobileItem.RightSide>
                                                <ArrowRightIcon/>
                                            </MobileItem.RightSide>
                                        </MobileItem>
                                    </div>
                                )
                            }
                        })}

                        {toogleValue === 1 && trolleyAndStationList.map((container) => {
                            if (container.type === WmsContainerType.PACKING_STATION) {
                                return (
                                    <div onClick={() => openContainerDrawer(container)}>
                                        <MobileItem>
                                            <MobileItem.LeftSide
                                                title={container.name}
                                                subtitle={<>{container.shipmentCount} <FormattedMessage
                                                    id={"wms.triShipping.shipmentCount"}/></>}
                                            />
                                            <MobileItem.RightSide>
                                                <ArrowRightIcon/>
                                            </MobileItem.RightSide>
                                        </MobileItem>
                                    </div>
                                )
                            }
                        })}
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}

export default TrolleyAndStationList;
